import { lazy } from 'react'

import { ERoutePaths } from './types'

import Home from 'pages/Home'
import News from 'pages/News'
import AboutUs from 'pages/AboutUs'
import Partners from 'pages/Partners'
import Services from 'pages/Services'
import Portfolio from 'pages/Portfolio'
import ContactUs from 'pages/ContactUs'
import ServiceDetail from 'pages/ServiceDetail'
import PortfolioDetail from 'pages/PortfolioDetail'

const Error = lazy(() => import('pages/Error'))

const routesList = [
  {
    element: Home,
    path: ERoutePaths.Home,
    title: 'home',
    description: 'aboutUsText',
    seoTitle: 'seoHomeTitle',
    seoDescription: 'seoHomeDesc',
  },
  {
    element: Services,
    path: ERoutePaths.Services,
    title: 'services',
    description: 'servicesPageSubtitle',
    seoTitle: 'seoServicesTitle',
    seoDescription: 'seoServicesDesc',
  },
  {
    element: ServiceDetail,
    path: ERoutePaths.ServiceDetail,
    title: 'services',
    description: 'servicesPageSubtitle',
    seoTitle: 'seoServicesTitle',
    seoDescription: 'seoServicesDesc',
  },
  {
    element: Portfolio,
    path: ERoutePaths.Portfolio,
    title: 'portfolio',
    description: 'portfolioSubtitle',
    seoTitle: 'seoPortfolioTitle',
    seoDescription: 'seoPortfolioDesc',
  },
  {
    element: PortfolioDetail,
    path: ERoutePaths.PortfolioDetail,
    title: 'portfolio',
    description: 'portfolioSubtitle',
    seoTitle: 'seoPortfolioTitle',
    seoDescription: 'seoPortfolioDesc',
  },
  {
    element: Partners,
    path: ERoutePaths.Partners,
    title: 'partners',
    description: 'comingSoonText',
  },
  {
    element: News,
    path: ERoutePaths.News,
    title: 'news',
    description: 'comingSoonText',
  },
  {
    element: AboutUs,
    path: ERoutePaths.AboutUs,
    title: 'aboutUs',
    description: 'aboutUsText',
    seoTitle: 'seoAboutTitle',
    seoDescription: 'seoAboutDesc',
  },
  {
    element: ContactUs,
    path: ERoutePaths.ContactUS,
    title: 'contactUs',
    description: 'contactText',
    seoTitle: 'seoContactTitle',
    seoDescription: 'seoContactDesc',
  },
  {
    element: Error,
    path: ERoutePaths.Error,
    title: 'error',
  },
]

export default routesList
